export const CASEDB_APP_ALERT_EVENT = 'casedb:app-alert';

let appAlertSequence = 0;

export const dispatchAppAlert = (alert = {}) => {
    if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') return null;

    appAlertSequence += 1;
    const id = String(alert.id || `app-alert-${Date.now()}-${appAlertSequence}`);
    window.dispatchEvent(new CustomEvent(CASEDB_APP_ALERT_EVENT, {
        detail: { ...alert, id }
    }));
    return id;
};
